export const CANVAS_SIZE = 512;

// Map canvas size to appropriate pixel size for optimal display
export const getPixelSizeForCanvas = (canvasSize: number): number => {
  const sizeMap: { [key: number]: number } = {
    1024: 1, // Largest canvas, smallest pixels for detail
    512: 2, // Medium-large canvas
    256: 3, // Medium canvas
    128: 4, // Default size
    64: 8, // Small canvas
    32: 16, // Smallest canvas, largest pixels
  };

  return sizeMap[canvasSize] || 4; // Default to 4 if size not found
};
